module.exports = __webpack_public_path__ + "static/img/kid-1.e380a5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kid-1.png
// module id = H5wY
// module chunks = 0